import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Badge, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader';
import { usePaymentStore } from "../../hooks/ai-hooks/usePaymentCredit";
import { fetchUserCredits } from "../../provider/paymentService";
import Swal from 'sweetalert2';

const PracticeWithAI = () => {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);
  const userId = sessionStorage.getItem("id")?.toString();
  const email = sessionStorage.getItem("email")?.toString();
  const name = sessionStorage.getItem("first_name")?.toString() + " " + sessionStorage.getItem("last_name")?.toString();
  const { credits, setPaymentData } = usePaymentStore()

  // useEffect(() => {
  //   fetchUserCredits(userId)
  //     .then((res) => {
  //       const { payType, userCredits } = res.data;
  //       setPaymentData({
  //         payType,
  //         userCredits,
  //       });
  //     })
  //     .catch(console.error);
  // },[]);

  useEffect(() => {
    fetchUserCredits({
      userId,
      name,
      email,
    })
      .then((res) => {
        const { payType, userCredits } = res.data;
        setPaymentData({
          payType,
          userCredits,
        });
      })
      .catch(console.error);
  }, [userId]);

  const practiceModules = [
    {
      id: 'debate',
      title: "Debate with AI",
      payID: "DE",
      subtitle: "Master the art of effective debating skills.",
      description: "Strengthen your reasoning, improve communication with one-on-one debates with the AI, boost your confidence and own the stage.",
      icon: "ri-p2p-line",
      iconColor: "#f49a09",
      gradientStart: "#f6a420",
      gradientEnd: "#db982e",
      isCommingSoon: false,
      stats: [
        { label: "Avg. Session", value: "15 min" },
        { label: "Difficulty Level", value: "3" },
      ],
      features: [
        "Critical Thinking",
        "Confidence Building",
        "Personalized improvement tips",
      ],
      path: "/practice-with-ai/debate",
      badge: "Popular",
      badgeVariant: "primary",
      buttonText: "Start Session",
      historyPath: "/practice-with-ai/debate/history",
    },
    {
      id: 'communication',
      title: "Communication Skills",
      payID: "CS",
      isCommingSoon: false,
      subtitle: "Master the art of effective communication",
      description: "Practice real-world conversations with AI-powered feedback. Improve your clarity, tone, and persuasion skills through interactive scenarios.",
      icon: "ri-chat-voice-line",
      iconColor: "#0d6efd",
      gradientStart: "#0d6efd",
      gradientEnd: "#0a58ca",
      stats: [
        { label: "Avg. Session", value: "15 min" },
        { label: "Difficulty Level", value: "3" },
        // { label: "Prep. Type", value: "3+" }
      ],
      features: [
        "Real-time pronunciation feedback",
        "Tone and clarity analysis",
        "Personalized improvement tips",
      ],
      path: "/practice-with-ai/communication-skills",
      badge: "Popular",
      badgeVariant: "primary",
      historyPath: "/practice-with-ai/communication-skills/history",
      isDisable: false,
    },
    {
      id: 'interview',
      title: "Interview Preparation",
      payID: "IV",
      subtitle: "Ace your next interview with confidence",
      description: "Experience realistic mock interviews with AI interviewers. Get instant feedback on your answers, body language cues, and presentation skills.",
      icon: "ri-video-chat-line",
      iconColor: "#6f42c1",
      isCommingSoon: false,
      gradientStart: "#6f42c1",
      gradientEnd: "#5a32a3",
      stats: [
        { label: "Avg. Session", value: "15 min" },
        { label: "Interview Type", value: "3" },
        // { label: "Success Rate", value: "89%" }
      ],
      features: [
        "Industry-specific questions",
        "Answer structure analysis",
        "Confidence metrics",
      ],
      path: "/practice-with-ai/interview-prep",
      badge: "New",
      badgeVariant: "success",
      historyPath: "/practice-with-ai/interview-prep/history",
      isDisable: false,
    }
  ];

  const handleStartSession = (module) => {
    const availableCredits = credits?.[module.payID] ?? 0;

    if (availableCredits === 0) {
      Swal.fire('Insufficient Credits', "You’ve used all credits. Upgrade your plan to continue practicing and improving 🚀", 'error')
      return
    }

    navigate(module.path)
  }


  return (
    <>
      <style>{`
        .practice-hero {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-bottom: 1px solid #dee2e6;
          padding: 2rem 0;
        }
        
        .practice-card {
          border: none;
          border-radius: 1rem;
          overflow: hidden;
          transition: all 0.3s ease;
          height: 100%;
        }
        
        .practice-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 1rem 3rem rgba(0,0,0,.175) !important;
        }
        
        .card-header-gradient {
          padding: 1.5rem;
          position: relative;
          overflow: hidden;
          color: white;
        }
        
        .card-header-gradient::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -20%;
          width: 200px;
          height: 200px;
          opacity: 0.1;
          font-size: 10rem;
        }
        
        .stats-row {
          background-color: #f8f9fa;
          border-top: 1px solid rgba(0,0,0,.05);
          border-bottom: 1px solid rgba(0,0,0,.05);
        }
        
        .stat-item {
          padding: 0.7rem;
          text-align: center;
          border-right: 1px solid #dee2e6;
        }
        
        .stat-item:last-child {
          border-right: none;
        }
        ul {
          margin-bottom: 0
        }
        
        .feature-list {
          list-style: none;
          padding: 0;
        }
        
        .feature-list li {
          padding: 0.1rem 0;
          padding-left: 1.5rem;
          position: relative;
        }
        
        .feature-list li::before {
          content: '•';
          position: absolute;
          left: 0;
          color: #6c757d;
          font-weight: bold;
        }
        
        .benefit-card {
          text-align: center;
          padding: 2rem 1.5rem;
          border-radius: 1rem;
          border: 1px solid #e9ecef;
          height: 100%;
          transition: all 0.3s ease;
        }
        
        .benefit-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 0.5rem 1rem rgba(0,0,0,.1);
        }
        
        .benefit-icon {
          width: 64px;
          height: 64px;
          border-radius: 1rem;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1rem;
        }
        
        .cta-section {
          background: linear-gradient(135deg, #0d6efd 0%, #6f42c1 100%);
          border-radius: 1rem;
          padding: 3rem 2rem;
          color: white;
          text-align: center;
        }
        
        .stats-badge {
          background-color: rgba(255,255,255,0.2);
          border-radius: 2rem;
          padding: 0.75rem 1.5rem;
        }
        
        .icon-wrapper {
          background-color: rgba(255,255,255,0.2);
          border-radius: 50%;
          width: 70px;
          height: 70px;
          padding: 0.7rem;
          backdrop-filter: blur(10px);
        }
      `}</style>

      <Container fluid>
        <Row>
          <Col>
            <PageHeader
              title="Practice With AI"
              breadcrumbs={[
                { label: "Dashboard", path: "/dashboard" },
                { label: "Practice With AI", active: true },
              ]}
            />
          </Col>
        </Row>

        <Row className="g-4 mt-2">
          {practiceModules.map((module) => {
            const hasCredits = (credits?.[module.payID] ?? 0) > 0;

            return (
              <Col key={module.id} lg={4}>
                <Card
                  className="practice-card"
                  onMouseEnter={() => setHoveredCard(module.id)}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div
                    className="card-header-gradient"
                    style={{
                      background: `linear-gradient(135deg, ${module.gradientStart} 0%, ${module.gradientEnd} 100%)`
                    }}
                  >
                    <div className="d-flex justify-content-center align-items-center mb-2">
                      <div className="icon-wrapper text-center">
                        <i className={module.icon} style={{ fontSize: '2rem', }}></i>
                      </div>
                      {/* {module.badge && (
                        <Badge bg={module.badgeVariant} className="px-3 py-2">
                          {module.badge}
                        </Badge>
                      )} */}
                    </div>
                    <div className="text-center">
                      <h3 className="h4 fw-bold mb-2 text-white">{module.title}</h3>
                      <p className="mb-0 opacity-60">{module.subtitle}</p>
                    </div>
                  </div>

                  <Row className="stats-row g-0">
                    {module.stats.map((stat, idx) => (
                      <Col key={idx} xs={4}>
                        <div className="stat-item">
                          <div className="fw-bold h5 mb-0">{stat.value}</div>
                          <div className="small text-muted">{stat.label}</div>
                        </div>
                      </Col>
                    ))}
                    <Col xs={4}>
                      <div className="stat-item">
                        <div className="fw-bold h5 mb-0">{module?.isCommingSoon ? 0 : credits?.[module.payID] ?? 0}</div>
                        <div className="small text-muted">Credits left</div>
                      </div>
                    </Col>
                  </Row>

                  <Card.Body className='mb-0 py-0 mt-2'>
                    <p className="text-muted mb-2">{module.description}</p>

                    <div className="mb-3">
                      <h5 className="h6 fw-semibold mb-2">
                        <i className="ri-award-line text-warning me-2"></i>
                        Key Features
                      </h5>
                      <ul className="feature-list text-muted p-0">
                        {module.features.map((feature, idx) => (
                          <li key={idx}>{feature}</li>
                        ))}
                      </ul>
                    </div>

                    <Button
                      variant="primary"
                      size="lg"
                      className="w-100 d-flex align-items-center justify-content-center"
                      onClick={() => handleStartSession(module)}
                      disabled={module.isDisable}
                      style={{
                        background: hasCredits && !module.isDisable
                          ? `linear-gradient(135deg, ${module.gradientStart} 0%, ${module.gradientEnd} 100%)`
                          : '#adb5bd',
                        // background: `linear-gradient(135deg, ${module.gradientStart} 0%, ${module.gradientEnd} 100%)`,
                        border: 'none',
                        cursor: hasCredits ? 'pointer' : 'not-allowed',
                        opacity: hasCredits ? 1 : 0.7
                      }}
                    >
                      {module.isDisable ? 'Comming Soon' : 'Start Session'}
                      <i className={`ri-arrow-right-line ms-2 ${hoveredCard === module.id ? 'ms-3' : ''}`}
                        style={{ transition: 'margin-left 0.3s ease' }}></i>
                    </Button>
                    {module.isDisable || (
                      <div className='w-100 d-flex justify-content-end mt-2' >
                        <Link to={module.historyPath} >View History</Link>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            )
          })}
        </Row>
      </Container>
    </>
  );
};

export default PracticeWithAI;